import { useMemo } from "react"
import DynamicComponent from "components/DynamicComponent"
import PhotoGrid from "components/DynamicComponent/molecules/PhotoGrid"
import CTABanner from "components/CTABanner"

export default function CareersPage({ story }) {
  const photos = useMemo(
    () =>
      story?.moments?.map((moment) => ({
        src: moment?.content.image.filename,
        blurDataURL: moment?.content.image.blurDataURL,
        uuid: moment?.content._uid,
        alt: moment?.content.image.alt,
      })),
    [story?.moments],
  )

  return (
    <main className="page-content">
      {story?.page?.content?.blocks.map((blok) => (
        <DynamicComponent blok={blok} key={blok._uid} />
      ))}
      <section className="bg-purple-gradient py-12 lg:py-16">
        <div className="container mx-auto">
          <div className="max-w-screen-xl mx-auto">
            <div className="text-center mx-auto max-w-xl 2xl:max-w-3l pb-8">
              {story?.page?.content?.moments_grid_eyebrow && (
                <span className="eyebrow eyebrow-2 text-green-kelly">{story?.page?.content?.moments_grid_eyebrow}</span>
              )}
              <h2 className="text-white font-bold">{story?.page?.content?.moments_grid_heading}</h2>
            </div>
          </div>
          {photos?.length ? (
            <PhotoGrid
              fallbackImage="/assets/blog-item-placeholder.svg"
              photos={photos}
              loading={false}
              mixSizes={true}
            />
          ) : null}
        </div>
      </section>
      <CTABanner
        heading={story?.page?.content?.cta_heading}
        asideText={story?.page?.content?.cta_aside_text}
        buttonText={story?.page?.content?.cta_button_text}
        buttonLink={story?.page?.content?.cta_button_link}
        content={story?.page?.content?.cta_content}
      />
    </main>
  )
}
